<div class="px-4 py-3 flex justify-content-between align-items-center w-100" [ngClass]="variant">
  <button
    pButton
    class="p-button p-button-primary p-button-outlined medium icon-only header-button"
    [style.visibility]="isBackButtonVisible ? 'visible' : 'hidden'"
    [activityLogClick]="AnalyticClickEventNames.navigation.BACK"
    (click)="backClicked()">
    <shared-icon icon="alt-arrow-left" height="1rem" width="1rem" />
  </button>

  <h2
    class="bold-800 text-center px-2 w-100 overflow-hidden text-ellipsis no-wrap"
    [ngClass]="{ 'text-18': titleSize === 'small', 'text-24': titleSize === 'medium' }">
    {{ headline }}
  </h2>

  @if (isMenuVisible) {
    <cp-multiaction-button
      buttonClass="header-button {{ variant === 'better-deal' ? 'color-light' : '' }}"
      [activityLogClick]="actionButtonActivityLogName"
      [menuItems]="menuItems" />
  } @else if (isActionButtonVisible) {
    <button
      pButton
      class="p-button p-button-primary p-button-outlined medium icon-only header-button"
      [activityLogClick]="actionButtonActivityLogName"
      (click)="emitActionClicked()">
      <shared-icon [icon]="actionIcon" [height]="actionIconSize ?? '1rem'" [width]="actionIconSize ?? '1rem'" />
    </button>
  } @else {
    <button
      class="p-button header-button"
      [style.visibility]="isMenuVisible || isActionButtonVisible ? 'visible' : 'hidden'"
      [activityLogClick]="actionButtonActivityLogName"></button>
  }
</div>
